// Consentimiento de cookies no necesarias (analítica y terceros).
// Google Analytics solo se inyecta tras "Aceptar": cargarlo desde index.html
// lo activaba antes de que el usuario eligiera, que es lo que prohíbe la LSSI.

const CLAVE = 'cookiesChoice';
const EVENTO = 'cookies-cambiadas';
const GA_ID = import.meta.env.VITE_GA_ID || 'G-5W7CRF4FBZ';

export type EleccionCookies = 'accepted' | 'rejected' | '';

export const leerEleccionCookies = (): EleccionCookies => {
  try {
    return (localStorage.getItem(CLAVE) as EleccionCookies) || '';
  } catch {
    return '';
  }
};

export const cookiesAceptadas = () => leerEleccionCookies() === 'accepted';

export function cargarAnalytics() {
  if (!GA_ID || document.getElementById('ga-script')) return;

  const w = window as unknown as { dataLayer: unknown[]; gtag: (...a: unknown[]) => void };
  w.dataLayer = w.dataLayer || [];
  w.gtag = function gtag() {
    // gtag necesita el objeto arguments, no un array
    // eslint-disable-next-line prefer-rest-params
    w.dataLayer.push(arguments);
  };
  w.gtag('js', new Date());
  w.gtag('config', GA_ID, { anonymize_ip: true });

  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function guardarEleccionCookies(eleccion: 'accepted' | 'rejected') {
  try {
    localStorage.setItem(CLAVE, eleccion);
  } catch {
    // sin almacenamiento: la elección vale solo para esta visita
  }
  if (eleccion === 'accepted') cargarAnalytics();
  window.dispatchEvent(new CustomEvent(EVENTO));
}

// Revoca la elección: borra las cookies de Analytics que hubiera y recarga
// para que el banner vuelva a salir y no quede nada cargado en memoria.
export function reiniciarEleccionCookies() {
  try {
    localStorage.removeItem(CLAVE);
  } catch {
    // nada que borrar
  }
  const dominio = window.location.hostname.replace(/^www\./, '');
  document.cookie.split(';').forEach((c) => {
    const nombre = c.split('=')[0].trim();
    if (!nombre.startsWith('_ga')) return;
    ['', `; domain=${dominio}`, `; domain=.${dominio}`].forEach((d) => {
      document.cookie = `${nombre}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`;
    });
  });
  window.location.reload();
}

export function alCambiarCookies(cb: () => void) {
  window.addEventListener(EVENTO, cb);
  return () => window.removeEventListener(EVENTO, cb);
}
